import React from 'react';
import './App.css';

import AppContainer from './Components/AppContainer';


function App() {
  return (

  <AppContainer className={'app'}/>
  );
}

export default App;
